import { useState, useEffect } from 'react'
import Store from '../../Store/Store';
import Request from '../../Request/Request';
import getData from './../getData';
import UploadFile from '../../Admin/UploadFile'

export default function Gallery( props ) {

	const table = props.table
	const ordinal = props.data.ordinal
	const tmp = props.tmp
	const setTmp = props.setTmp
	const [ images, setImages ] = useState( Store.get( 'images-' + table + '-' + ordinal ) || [] )

	function deleteImage( fileUri ) {
		const uriParts = fileUri.split( '/' )
		if ( uriParts.length > 0 ) {
			const file_name = uriParts.slice(-1)[0]
		    Request.delete( 'image', { table, ordinal, file_name },  
				result => getImages(),
				error => console.error( error )
		    )
		}
	}

	function getImages() {
		if ( !ordinal ) return false
		const path = 'gallery/' + table + '/' + ordinal
		getData( path, null, d => { 
			const imagesTmp = []
			const imageRoot = 'https://carat80.com/api/image/'
			if ( d && d.hasOwnProperty( 'images' ) && d.images.length > 0 ) {
				d.images.forEach( a => {
					const imagePath = imageRoot + table + '/' + ordinal + '/' + a
					imagesTmp.push( imagePath )
					// cache
					const tmp = new Image()
	          		tmp.src = imagePath
				} )
			}
			setImages( imagesTmp )
			Store.set( 'images-' + table + '-' + ordinal, imagesTmp )
		} )
	}

	function onComplete( d ) {
		getImages()
	}

	useEffect(() => {
		getImages()
	}, [ table, ordinal ] ) ;

	if ( !ordinal ) return false

	return(
		<tr><td colSpan={ 2 } style={{ border:'none', padding:20 }} >

			{ images && images.length > 0 && images.map( a => (
				<div key={ a } style={{ display:'inline-block', verticalAlign: 'middle', position:'relative' }} >
					<img 
						src={ a } 
						style={{ 
							maxWidth:110, maxHeight:65, margin:5, 
							border:'5px solid white', boxShadow:'0 2px 6px #00000088',
							verticalAlign:'middle',  
						}} 
					/>
					<div 
						className="image-delete"
						onClick={ e => deleteImage( a ) }
						style={{ 
							position:'absolute', userSelect:'none',
							top:5, right:5, width:28, height:28, 
							background:'#ff1744', color:'white', cursor:'pointer', 
							fontWeight:600, padding:'5px 10px',
							borderRadius:14, boxSizing:'border-box', 
							boxShadow:'0 1.5px 3px #00000088',
						}} 
					>
						x
					</div>
				</div>
			) ) }
			<div style={{ display:'inline-block', verticalAlign: 'middle' }} >
				<UploadFile {...{ table, ordinal, tmp, setTmp, onComplete }}  />
			</div>
			
		</td></tr>
	)
}
